// extracted by mini-css-extract-plugin
export default {"markdown":"SurveyNode_markdown__Uthde","editor":"SurveyNode_editor__IJuCv"};